import type { TourSection } from './types';

export const webhookBackfillsSections: TourSection[] = [
  {
    id: 'new',
    label: 'Nuevo backfill',
    steps: [
      {
        target: '[data-tour="webhook-backfills-new"]',
        title: 'Lanzar backfill',
        content:
          'Empuja un lote de productos a los clientes B2B suscritos. Úsalo para onboarding de un cliente nuevo, resync de una marca/categoría, o recuperar eventos que no llegaron. Se ignora el dedup — siempre envía.',
      },
    ],
  },
  {
    id: 'filters',
    label: 'Filtros de backfills',
    steps: [
      {
        target: '[data-tour="webhook-backfills-filters"]',
        title: 'Filtros',
        content:
          'Filtra por estado del backfill: pendiente, en curso, completado, fallado o cancelado.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado de backfills',
    steps: [
      {
        target: '[data-tour="webhook-backfills-table"]',
        title: 'Backfills lanzados',
        content:
          'Cada fila muestra el objetivo (SKUs, marca, categoría o todo), la cantidad de clientes destino, y el progreso live (procesados / totales estimados). Click para ver el detalle y cancelar si sigue activo.',
      },
    ],
  },
];
